var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.path)?_c('img',{staticClass:"image",attrs:{"src":_vm.content.path,"alt":_vm.content.alt,"title":_vm.content.title}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }